import 'styles'
import Root from './containers/Root'
import configureStore from './store/configureStore'
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

const { persistor, store } = configureStore()

const polyfillIntlIfNeeded = cb => () => {
  if (!global.Intl) {
    require.ensure([
      'intl',
      'intl/locale-data/jsonp/en.js',
    ], (require) => {
      require('intl')
      require('intl/locale-data/jsonp/en.js')
      cb()
    })
  } else {
    cb()
  }
}

const runApp = () => () => (
  createRoot(
    document.getElementById("mount"),
  )
  .render(
    <StrictMode>
      <Root
          store={store}
          persistor={persistor}
        />
    </StrictMode>,
  )
)

const run = () => {
  const renderApp = runApp();
  const withPolyfill = polyfillIntlIfNeeded(renderApp);
  withPolyfill();
} 

run()

if (module.hot) {
  module.hot.accept('./containers/Root', run)
}
